import { FieldStatus } from "modules/PsyCatalog/common/services/FieldStatus"
import { ctx } from "modules/PsyCatalog/common/ctx"
import { getCurrentPage } from "modules/PsyCatalog/common/utils"
import { runSearchRequest } from "modules/PsyCatalog/common/models/searchRequest"
import { formAtom } from "modules/PsyCatalog/common/models/filterForm"

ctx.subscribe(FieldStatus.readyAtom, (ready) => {
    ready && void runSearchRequest(ctx, ctx.get(formAtom), getCurrentPage())
})
